// Vuex
import { mapState, mapActions } from 'vuex'

// Mixins 
import matrixCompatibilityIndex from '@/servicios/matrizCompatibilidad/compatibility/index.js'
import Pusher from 'pusher-js'

export default {

    name: 'compatibilityMatrixComparisonIA',

    data() {
        return {
            show: false,
            activeProductList: null,
            productsAttachments: [],
            progress: {
                value: 0,
                max: 100,
                message: ''
            },
            pusherChannel: null
        }
    },

    mixins: [matrixCompatibilityIndex],

    computed: {

        ...mapState('compatibilityMatrixComparisonIA', [
            'scheduledProcessesLoading',
            'scheduledProcesses'
        ]),

        ...mapState('matrizCompatibilidadAlmacenamiento', {
            comparison: 'comparacion',
            selectedProducts: 'productos_seleccionados',
        }),

        showProgressStatus() {
            return typeof this.scheduledProcesses === 'object' && this.scheduledProcesses
        },

        getStatusTitleSchedule() {

            let title = 'PENDIENTE'
            if (!this.scheduledProcesses) {
                return title
            }
            
            if (this.scheduledProcesses.status === 'processing') {
                title = 'EN PROGRESO';
            }
            else if (this.scheduledProcesses.status === 'success') {
                title = 'COMPLETADO EXITOSAMENTE';
            }
            else if (this.scheduledProcesses.status === 'failed') {
                title = 'FINALIZO CON FALLOS';
            }

            return title
        },

        getVariantToProgressBar() {

            if (!this.scheduledProcesses) {
                return 'danger'
            }

            return this.isCompletedProgress ? 
                (this.scheduledProcesses.status === 'failed' ? 'danger' : 'success') : 
                'primary'
        },

        isCompletedProgress() {
            return this.progress.value === 100
        }

    },

    watch: {
        scheduledProcesses(next, old) {
            if ((!(next !== old) && !next) || !this.scheduledProcesses) return
     
            let value = 0
            let message = ''
            
            if (this.scheduledProcesses.status === 'processing') {
                value = !Number.isFinite(this.scheduledProcesses.details) ? 0 : this.scheduledProcesses.details;
                
                // Extraer mensaje del chunk actual
                if (this.scheduledProcesses.meta) {
                    try {
                        const meta = JSON.parse(this.scheduledProcesses.meta)
                        message = meta.message || 'Procesando...'
                    } catch (e) {
                        message = 'Procesando...'
                    }
                }
            }
            else if (this.scheduledProcesses.status === 'success') {
                value = 100;
                message = 'Completado exitosamente'
                this.unsubscribePusher()
                this.updateDataToComparison()
            }
            else if (this.scheduledProcesses.status === 'failed') {
                value = 100;
                message = 'Finalizado con errores'
                this.unsubscribePusher()
                this.updateDataToComparison()
            }

            this.progress.value = value
            this.progress.message = message
        }
    },

    methods: {

        ...mapActions('compatibilityMatrixComparisonIA', [
            'getComparisonsByMatrixId',
            'generateProductComparisonIA',
        ]),

        getProductByAttribute(param, value) {            
            return this.selectedProducts.find(x => x[param] === value)
        },

        /**
         * Suscribirse a Pusher para recibir actualizaciones de progreso en tiempo real
         */
        subscribeToPusher() {
            if (!this.comparison || !this.comparison.id) {
                console.warn('No hay matriz seleccionada para suscripción Pusher')
                return
            }
            
            Pusher.logToConsole = false
            
            const pusher = new Pusher('5c41c1dc4bec329b2165', {
                cluster: 'us2'
            })
            
            const channelName = `ia-job-progress-${this.comparison.id}`
            this.pusherChannel = pusher.subscribe(channelName)
            
            this.pusherChannel.bind('job-progress', (data) => {

                const mensaje = data.mensaje
                
                this.progress.value = mensaje.percentage
                this.progress.message = mensaje.message
                
                // Si el proceso terminó, actualizar datos
                if (mensaje.status === 'success' || mensaje.status === 'failed') {
                    this.unsubscribePusher()
                    this.updateDataToComparison()
                    this.onHandleRefresh()
                }
            })
        },

        /**
         * Cancelar suscripción a Pusher
         */
        unsubscribePusher() {
            if (!this.pusherChannel) return
            
            const channelName = `ia-job-progress-${this.comparison.id}`
            this.pusherChannel.unsubscribe(channelName)
            this.pusherChannel = null
        },
        
        generateStructureToSave() {
            let productsData = this.onOrderByProducts(this.selectedProducts) 
            let quantity = 0;
            const products = []
                        
            productsData.map((x, xi) => {
                let comparison = []
                const productsToCompare = productsData.slice(xi + 1) // +1 para excluir el producto actual
                productsToCompare.map(y => {
                    let compatibilityStatus = this.getCompatibilityStatus(this.comparison, x, y);
                    let verification = this.verification(this.comparison, x, y);
                    if (compatibilityStatus === 'revision' && verification) {
                        comparison.push({
                            id: y.id, 
                            name: y.nombre,
                            status: compatibilityStatus,
                            verification,
                            path: this.getAttachmentPathByproductId(y.id)
                        })
                    }                    
                })    
                
                const itemsToComparison = comparison
                products.push({
                    id: x.id,
                    name: x.nombre,
                    path: this.getAttachmentPathByproductId(x.id),
                    comparison: itemsToComparison
                })

                quantity += itemsToComparison.length;
            })
            
            const { id, id_empresa: company } = this.comparison

            return {
                matrixId: id,
                companyId: company,
                products, 
                quantity 
            }
        },

        async onHandleGenerateProcess() {            
            const payload = {
                params: this.generateStructureToSave(),
                callback: this.onHandleGenerateProcessCallback
            }
            await this.generateProductComparisonIA(payload)
        },

        onHandleGenerateProcessCallback(success) {
            if (!success) return

            // Cerrar modal detalles productos
            this.onHandleRefresh()
            
            this.subscribeToPusher()
        },

        async onGetComparisonsByMatrixId() {
            const payload = {
                params: { id: this.comparison.id, companyId: this.comparison.id_empresa },
                callback: this.onGetComparisonsByMatrixIdCallback
            }
            await this.getComparisonsByMatrixId(payload)
        },

        onGetComparisonsByMatrixIdCallback(success) {
            if (!success) return
        },

        onHandleRefresh() {            
            this.onGetComparisonsByMatrixId()
        },

        getAttachmentPathByproductId(id) {
            const product = this.productsAttachments.find(pa => pa.id === id)
            return product ? product.path : null
        },

        onOrderByProducts(data) {
            return data.sort((a, b) => {
                const nameA = a.nombre.toUpperCase();
                const nameB = b.nombre.toUpperCase();

                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                
                return 0;
            })
        }

    },

    beforeUnmount() {
        this.unsubscribePusher()
    }

}